export const GET_VALUE_HELPS = "GET_VALUE_HELPS";
export const VALUE_HELPS = "VALUE_HELPS";
export const LOAD_SCRIPT = "LOAD_SCRIPT";
export const SEND_WHATAPP_MESSAGE = "SEND_WHATAPP_MESSAGE";
export const UPLOAD_USER_DOCUMENT = "UPLOAD_USER_DOCUMENT";
export const UPLOAD_USER_DOCUMENT_RESP = "UPLOAD_USER_DOCUMENT_RESP";
export const DOWNLOAD_USER_DOCUMENT = "DOWNLOAD_USER_DOCUMENT";
export const DOWNLOAD_USER_DOCUMENT_RESP = "DOWNLOAD_USER_DOCUMENT_RESP";